<template>
  <div class="cms-content-render" :class="'layout-' + layout">
    <!-- 移动端内容 -->
    <template v-if="layout === 'mobile'">
      <div v-if="contentMode === 'singleinfo'" class="rich" v-html="formatRichText(text)"></div>
      <div class="development-history" v-else-if="contentMode === 'timeline'">
        <div class="date-range">{{ data }}</div>
        <div class="list" v-for="(item, index) in snckData" :key="index">
          <div class="item" v-for="(item1, index1) in item" :key="index1">
            <div class="left"><div class="square"></div></div>
            <div class="right">
              <div class="title" v-if="item1.contentTitle">{{ item1.contentTitle }}</div>
              <div class="description" v-html="item1.contentDescription"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="certificate-list" v-else-if="contentMode === 'certificate'">
        <div class="item" v-for="item in snckData" :key="item.id">
          <img :src="webImg + item.contentImg + imgCut(305,381)" alt="" @dragstart.prevent>
          <div v-if="item.contentTitle">{{ item.contentTitle }}</div>
        </div>
      </div>
      <div class="picture-gallery" v-else-if="contentMode === 'pictureGallery'">
        <div class="picture-gallery-item" v-for="item in snckData" :key="item.id">
          <img :src="webImg + item.contentImg + imgCut(900, 600)" alt="" @dragstart.prevent v-if="item.contentImg">
        </div>
      </div>
      <div class="article-list" v-else-if="contentMode === 'articleList' || contentMode === 'textList'">
        <div class="article-list-item" v-for="item in articleList" :key="item.id" @click="onArticleClick(item)">
          <div class="article-title txt-ellipsis-2">{{ item.contentTitle }}</div>
          <div class="article-time" v-if="item.createTime">{{ item.createTime.slice(0, 10) }}</div>
        </div>
      </div>
      <div v-else-if="contentMode === 'contactPanel'" class="contact-panel">
        <div id="map-mobile" style="width: 8.933333rem; height: 6.666667rem; margin-top: 0.266667rem"></div>
        <div class="info">
          <div class="companyName">{{ info.companyName }}</div>
          <div class="address">{{ $t('common.address') }}：{{ info.address }}</div>
          <div class="address">{{ $t('common.postcode') }}：{{ info.dawk }}</div>
          <div class="address" v-for="(phone, idx) in info.phone" :key="idx">{{ phone.key }}：{{ phone.value }}</div>
          <div class="address">{{ $t('common.fax') }}：{{ info.fax }}</div>
        </div>
      </div>
      <div v-else-if="contentMode === 'articleDetail'" class="detail" v-html="formatRichText(contentDetails)"></div>
    </template>

    <!-- PC 内容 -->
    <template v-else>
      <div class="right" v-if="contentMode === 'timeline'" style="padding-top: 120px;">
        <div class="mainSnakLine" v-for="(item, index) in snckData" :key="index">
          <div class="mainSnakLine0"></div>
          <div class="mainSnakLine1" v-if="index % 2 == 0 && isShow1 > 2 * index"></div>
          <div class="mainSnakLine2" v-if="index % 2 != 0 && isShow1 > 2 * index"></div>
          <div class="mainBoxRight0" v-if="index % 2 == 0 && index != snckData.length - 1"></div>
          <div class="mainBoxRight" v-if="index % 2 == 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1"></div>
          <div class="mainBoxRight1" v-if="index % 2 == 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1"></div>
          <div class="mainBoxLeft0" v-if="index % 2 != 0 && index != snckData.length - 1"></div>
          <div class="mainBoxLeft" v-if="index % 2 != 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1"></div>
          <div class="mainBoxLeft1" v-if="index % 2 != 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1"></div>
          <div v-if="index == 0" class="mainBoxData">{{ data }}</div>
          <div class="mianBox" v-for="(item1, index1) in item" :key="index1">
            <div class="mianBoxTitle" v-if="item1.contentTitle">{{ item1.contentTitle }}</div>
            <div class="mianBoxDescription" v-html="item1.contentDescription"></div>
          </div>
        </div>
      </div>
      <div v-else-if="contentMode === 'certificate'" class="right" style="padding: 0;">
        <div style="width: 92%;border-bottom: 1px solid #ededed;display: flex;cursor: pointer;margin: 0 auto;margin-top: 10px;">
          <div @click="switchCertificateType(index + 1)" class="typeStyle" :class="{ typeStyle1: contentType == (index+1) }"
            v-for="(item, index) in typeList" :key="index">{{ item }}</div>
        </div>
        <div class="rightMain">
          <div class="rightMainItem" v-for="item in snckData" :key="item.id">
            <img :src="webImg + item.contentImg" alt="" @dragstart.prevent style="border: 0.5px solid #e5e5e5">
            <div v-if="item.contentTitle" class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
          </div>
        </div>
        <div v-if="snckData.length > 0" style="height: 130px;display: flex;align-items: center;justify-content: center;">
          <el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize" @current-change="handleCurrentChange" />
        </div>
      </div>
      <div v-else-if="contentMode === 'pictureGallery'" class="right org-chart">
        <div class="org-chart-item" v-for="item in snckData" :key="item.id">
          <img :src="webImg + item.contentImg + imgCut(900, 600)" alt="" @dragstart.prevent v-if="item.contentImg">
        </div>
      </div>
      <div v-else-if="contentMode === 'articleList' || contentMode === 'textList'" class="right article-panel" style="padding: 0;">
        <template v-if="articleListLayout === 'card'">
          <div class="newsItem" v-for="item in articleList" :key="item.id" @click="onArticleClick(item)">
            <img :src="webImg + item.contentImg + imgCut(200, 150)" alt="" v-if="item.contentImg" @dragstart.prevent>
            <div class="newsItem-content">
              <div class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
              <div class="time">{{ item.createTime }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="article-list-row" v-for="item in articleList" :key="item.id" @click="onArticleClick(item)">
            <div class="article-list-title txt-ellipsis-2">{{ item.contentTitle }}</div>
            <div class="article-list-time" v-if="item.createTime">{{ item.createTime }}</div>
          </div>
        </template>
        <div v-if="articleList.length > 0" style="height: 130px;display: flex;align-items: center;justify-content: center;">
          <el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize"
            :current-page="pageNum" @current-change="handleArticlePageChange" />
        </div>
      </div>
      <div v-else-if="contentMode === 'contactPanel'" class="right contact-panel">
        <div class="contact-map">
          <div id="map-pc"></div>
        </div>
        <div class="contact-info">
          <div class="companyName">{{ info.companyName }}</div>
          <div class="address">{{ $t('common.address') }}：{{ info.address }}</div>
          <div class="address">{{ $t('common.postcode') }}：{{ info.dawk }}</div>
          <div class="address" v-for="(phone, idx) in info.phone" :key="idx">{{ phone.key }}：{{ phone.value }}</div>
          <div class="address">{{ $t('common.fax') }}：{{ info.fax }}</div>
        </div>
      </div>
      <div v-else-if="contentMode === 'articleDetail'" class="right" style="padding: 10px; position: relative;">
        <div style="margin: 0 auto;font-weight: 600;font-size: 20px;text-align: center;" v-html="title"></div>
        <div style="margin: 0 auto;font-weight: 400;font-size: 14px;text-align: center;color: #333;margin-top: 20px;">
          {{ $t('common.publishTime') }}:{{ createTime }}</div>
        <div style="width: 900px;margin: 0 auto;height: 2px;background: #c1c1c1;margin-top: 10px;"></div>
        <div v-html="formatRichText(contentDetails)" style="padding-bottom: 20px;"></div>
        <div class="article-nav">
          <div class="upNews" @click="upNewsClick()" v-if="flippingList[0] && flippingList[0].contentTitle">
            <span class="upNewsIcon">{{ $t('common.prevArticle') }}</span>
            <span class="upNewsText">{{ flippingList[0].contentTitle }}</span>
          </div>
          <div class="upNews" @click="nextNewsClick()" v-if="flippingList[2] && flippingList[2].contentTitle">
            <span class="upNewsIcon">{{ $t('common.nextArticle') }}</span>
            <span class="upNewsText">{{ flippingList[2].contentTitle }}</span>
          </div>
        </div>
      </div>
      <div class="right ftRight" v-else-if="contentMode === 'singleinfo'" v-html="formatRichText(text)"></div>
    </template>
  </div>
</template>
<script>
	import {
		singleinfo,
		contentList,
		contentPage,
		flipping,
		contactUs,
	} from '@/api/api'
	import { resolveSingleInfoId, resolveArticleListLayout } from '@/utils/cmsNav'
	var num = 0;
	export default {
		name: 'CmsContentRender',
		props: {
			layout: { type: String, default: 'pc' },
			contentMode: { type: String, default: 'empty' },
			menuItem: { type: Object, default: null },
			reloadToken: { type: Number, default: 0 },
			parentId: { type: [String, Number], default: '' },
			search: { type: String, default: '' },
			contentId: { type: [String, Number], default: '' },
		},
		data() {
			return {
				text: '',
				data: '',
				snckData: [],
				pageNum: 1,
				pageSize: 9,
				total: 0,
				menuId: '',
				isShow1: -1,
				contentType: 1,
				articleList: [],
				info: { phone: [] },
				title: '',
				createTime: '',
				contentDetails: '',
				newsId: '',
				flippingList: [],
				_articleRequestSeq: 0,
			}
		},
		computed: {
			typeList() {
				return [this.$t('about.companyQualification'), this.$t('about.companyHonor')];
			},
			articleListLayout() {
				return resolveArticleListLayout(this.menuItem)
			},
			mapElementId() {
				return this.layout === 'mobile' ? 'map-mobile' : 'map-pc'
			},
		},
		watch: {
			contentMode: 'loadContent',
			menuItem: 'loadContent',
			reloadToken: 'loadContent',
			contentId(val) {
				if (val && this.contentMode === 'articleDetail') {
					this.loadArticleDetail(val)
				}
			},
		},
		mounted() {
			this.loadContent()
			if (this.layout === 'pc') {
				window.addEventListener('scroll', this.handleScroll, true)
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll, true)
		},
		methods: {
			handleScroll() {
				if (this.contentMode !== 'timeline') return
				if (this.isShow1 % 2 !== 0) return
				if (new Date().getTime() - num <= 1000) return
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				const rows = this.$el ? this.$el.querySelectorAll('.mainSnakLine') : []
				const rowIndex = this.isShow1 / 2
				let threshold = 240
				for (let i = 0; i < rowIndex; i++) {
					threshold += (rows[i] && rows[i].offsetHeight) || 290
				}
				if (scrollTop > threshold) {
					this.isShow1++
					setTimeout(() => {
						this.isShow1++
						num = new Date().getTime()
					}, 2000)
				}
			},
			loadContent() {
				if (!this.menuItem && this.contentMode !== 'articleDetail') return
				this.loadByMode(this.contentMode, true)
			},
			loadByMode(mode, reload) {
				if (reload) {
					this.text = ''
					this.snckData = []
					this.articleList = []
					this.data = ''
					this.isShow1 = -1
					this.pageNum = 1
				}
				if (mode === 'articleDetail') {
					if (this.menuItem) this.menuId = this.menuItem.menuId
					if (this.contentId) this.loadArticleDetail(this.contentId)
					return
				}
				if (!this.menuItem) return
				this.menuId = this.menuItem.menuId
				if (mode === 'singleinfo') {
					const singleId = resolveSingleInfoId(this.menuItem)
					if (singleId) this.getSingleinfo(singleId)
					return
				}
				if (mode === 'timeline') {
					this.getTimelineList(this.menuId)
					return
				}
				if (mode === 'certificate') {
					this.contentType = 1
					this.getCertificatePage(this.menuId)
					return
				}
				if (mode === 'pictureGallery') {
					this.getPictureList(this.menuId)
					return
				}
				if (mode === 'articleList' || mode === 'textList') {
					this.pageSize = 10
					this.getArticlePage()
					return
				}
				if (mode === 'contactPanel') {
					this.getContactUs()
				}
			},
			getArticlePage() {
				if (!this.menuId) return
				const requestMenuId = this.menuId
				const requestPage = this.pageNum
				this._articleRequestSeq = (this._articleRequestSeq || 0) + 1
				const requestSeq = this._articleRequestSeq
				contentPage(requestPage, this.pageSize, requestMenuId, '', 1).then((res) => {
					if (requestSeq !== this._articleRequestSeq) return
					if (String(requestMenuId) !== String(this.menuId)) return
					if (requestPage !== this.pageNum) return
					const list = res.data || []
					const seen = new Set()
					this.articleList = list.filter((item) => {
						if (!item || item.id === undefined || item.id === null) return true
						if (seen.has(item.id)) return false
						seen.add(item.id)
						return true
					})
					this.total = res.total != null ? res.total : this.articleList.length
				})
			},
			handleArticlePageChange(page) {
				if (page === this.pageNum) return
				this.pageNum = page
				this.getArticlePage()
			},
			onArticleClick(item) {
				if (!item || !item.id) return
				this.$emit('open-article', item)
			},
			getPictureList(menuId) {
				this.menuId = menuId
				contentList(menuId).then((res) => {
					this.snckData = res.data || []
				})
			},
			getSingleinfo(id) {
				singleinfo(id).then(res => {
					this.text = (res.data && res.data.content) || ''
				})
			},
			getContactUs() {
				contactUs().then((res) => {
					this.info = res.data || {}
					try {
						this.info.phone = JSON.parse(this.info.phone || '[]')
					} catch (e) {
						this.info.phone = []
					}
					this.$nextTick(() => {
						setTimeout(() => this.initMap(), 300)
					})
				})
			},
			initMap() {
				if (!this.info.lng || !this.info.lat || typeof AMap === 'undefined') return
				const map = new AMap.Map(this.mapElementId, {
					viewMode: '2D',
					zoom: 16,
					center: [this.info.lng, this.info.lat],
				})
				new AMap.Marker({
					map,
					position: [this.info.lng, this.info.lat],
				})
			},
			loadArticleDetail(id) {
				this.newsId = id
				flipping(this.menuId, id).then((res) => {
					const data = res.data || []
					this.contentDetails = (data[1] && data[1].contentDetails) || ''
					this.title = (data[1] && data[1].contentTitle) || ''
					this.createTime = (data[1] && data[1].createTime) || ''
					this.flippingList = data
				})
			},
			upNewsClick() {
				if (!this.flippingList[0]) return
				this.loadArticleDetail(this.flippingList[0].id)
				document.documentElement.scrollTop = 0
			},
			nextNewsClick() {
				if (!this.flippingList[2]) return
				this.loadArticleDetail(this.flippingList[2].id)
				document.documentElement.scrollTop = 0
			},
			switchCertificateType(type) {
				if (this.contentType === type) return
				this.contentType = type
				this.pageNum = 1
				if (this.menuId) this.getCertificatePage(this.menuId)
			},
			getTimelineList(menuId) {
				this.menuId = menuId
				this.isShow1 = -1
				num = 1
				contentList(menuId).then(res => {
					if (res.data[0] && res.data[0].contentTitle) {
						this.data = res.data[0].contentTitle
					} else {
						this.data = ''
					}
					const dataArr = this.setTwoDimensionalArray(res.data.filter(item => item.contentSort != 1))
					this.snckData = this.setReverseArray(dataArr)
					this.isShow1 = 0
				})
			},
			getCertificatePage(menuId) {
				this.menuId = menuId
				contentPage(this.pageNum, this.pageSize, menuId, '', 1, '', 0, this.contentType).then(res => {
					this.snckData = res.data || []
					this.total = res.total || 0
				})
			},
			handleCurrentChange(e) {
				this.pageNum = e
				this.getCertificatePage(this.menuId)
			},
			// 转化函数
			setTwoDimensionalArray(list) {
				const listResult = []; // 最终返回的二维数组
				for (let i = 0; i < Math.ceil((list.length / 2)); i++) {
					listResult[i] = [];
					for (let j = 0; j < 2; j++) {
						// 如果是最后一个板块
						if (i === (Math.ceil((list.length / 2)) - 1)) {
							if (Math.ceil((list.length % 2)) !== 0) {
								// 只有最后一个板块的数据在余数以内的才赋值
								if (j < Math.ceil((list.length % 2))) {
									listResult[i][j] = list[i * 2 + j];
								}
							} else {
								// 如果刚好整整一个板块，则全部附上值
								listResult[i][j] = list[i * 2 + j];
							}
						} else {
							listResult[i][j] = list[i * 2 + j];
						}
					}
				}
				return listResult;
			},
			//翻转数组
			setReverseArray(list) {
				list.forEach((item, index) => {
					if (index % 2 != 0) {
						item = item.reverse()
					}
				});
				return list;
			},
			initSnckLine: function() {
				// this.calColNum();

				if (this.data.length > 0) {
					this.calRowNum();
				}
			},

			// /**
			//  * 计算一行显示的列数
			//  */
			// calColNum: function () {
			//     this.colNum = 2
			// },

			/**
			 * 计算需要多少行显示完
			 */
			calRowNum() {
				var length = this.data.length;
				if (this.colNum > length) {
					this.rowNum = 1;
				} else {
					this.rowNum = Math.floor(length / this.colNum);

					if (length % this.colNum > 0) {
						this.rowNum++;
					}
				}

				this.initsSnckData();
			},
			/**
			 * 初始化蛇形展示数据
			 * 得到一个二位数组
			 */
			initsSnckData: function() {
				// var that = this;
				// var newArr = [];
				// if (this.rowNum == 1) {
				//     newArr.push(that.data);
				// } else {
				//     for (var i = 0; i <= that.data.length; i += that.colNum) {
				//         var arr = that.data.slice(i, i + that.colNum);
				//         newArr.push(arr);
				//     }
				// }

				// if (newArr.length > 0) {
				//     newArr.forEach(function (item, index) {
				//         newArr[index] = that.getRowData(item, index);
				//     });
				// }

				// that.snckData = newArr;
				// console.log(newArr)
			},
			getRowData: function(data, index) {
				return (index % 2) == 0 ? data : data.reverse();
			},
			getWczt: function(ztdm) {
				var className = '';
				switch (ztdm) {
					case 1: //已完成
						className = 'green';
						break;
					case 2: //未完成
						className = 'yellow'
						break;
					case 3: //未开始
						className = 'red'
						break;
				}

				return className;
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					return match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					return match.replace(/width:[^;]+;/gi, 'max-width:100%;');
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi,
					'<img style="max-width:95%;height:auto;display:inline-block;margin:10px auto;"');
				return newContent;
			},
		},
	}
</script>

<style scoped lang="scss">
.layout-mobile {
  width: 100%;

  .rich {
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    font-size: 0.213333rem;

    p img {
      text-indent: 0 !important;
    }
  }

  .development-history {
    width: 100%;
    box-sizing: border-box;
    padding: 0.533333rem;

    .date-range {
      width: 2.666667rem;
      height: 0.853333rem;
      margin-bottom: 0.8rem;
      background: #0175c2;
      font-size: 0.4rem;
      color: #fff;
      line-height: 0.853333rem;
      text-align: center;
    }

    .list .item {
      display: flex;

      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 0.4rem;

        .square {
          width: 0.32rem;
          height: 0.32rem;
          background: #fff;
          box-shadow: 0 0.053333rem 0.053333rem rgba(5, 89, 187, 0.25);
          border: 0.053333rem solid #0175c2;
        }
      }

      .right {
        .title {
          font-size: 0.373333rem;
          color: #000;
        }

        .description {
          font-size: 0.32rem;
          color: #666;
          padding: 0.266667rem 0;
          min-height: 1.333333rem;
        }
      }
    }
  }

  .certificate-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .item {
      margin-bottom: 0.266667rem;
      width: 4.6rem;
      box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.1);
      padding: 0.266667rem 0.266667rem 0;

      img {
        width: 100%;
        height: 5.066667rem;
        object-fit: contain;
      }

      div {
        height: 1.146667rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.346667rem;
        color: #333;
        text-align: center;
      }
    }
  }

  .picture-gallery-item {
    width: 100%;
    margin-bottom: 0.266667rem;

    img {
      width: 100%;
      height: auto;
    }
  }

  .article-list-item {
    padding: 0.32rem 0;
    border-bottom: 1px dashed #e5e5e5;

    .article-title {
      font-size: 0.373333rem;
      color: #333;
      margin-bottom: 0.16rem;
    }

    .article-time {
      font-size: 0.32rem;
      color: #999;
    }
  }

  .contact-panel {
    padding: 0 0.266667rem 0.533333rem;

    .info {
      padding-bottom: 0.266667rem;
    }

    .companyName {
      font-size: 0.4rem;
      font-weight: bold;
      margin-top: 0.266667rem;
    }

    .address {
      font-size: 0.346667rem;
      color: #666;
      margin-top: 0.133333rem;
      line-height: 1.5;
      word-break: break-word;
    }
  }
}

.layout-pc {
  .right {
    width: 925px;
    min-height: 600px;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
  }

  .ftRight p img {
    text-indent: 0 !important;
  }

  .rightMain {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;

    .rightMainItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 50px;
      margin-left: 52px;

      .title {
        width: 240px;
        font-size: 18px;
        color: #333;
        text-align: center;
      }

      img {
        width: 240px;
        height: 300px;
        margin-bottom: 20px;
        box-shadow: 0 0 16px 5px #e0dedf;
        object-fit: contain;
      }
    }
  }

  .mainSnakLine {
    width: 558px;
    min-height: 290px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: stretch;
  }

  .mainSnakLine0 {
    width: 558px;
    height: 2px;
    background: #f4f4f4;
    position: absolute;
    top: 0;
    left: 0;
  }

  .mainSnakLine1,
  .mainSnakLine2 {
    width: 558px;
    height: 2px;
    background: #0175c2;
    position: absolute;
    top: 0;
    animation: widthAni 2s linear 1;
  }

  .mainSnakLine1 { left: 0; }
  .mainSnakLine2 { right: 0; }

  .mainBoxRight,
  .mainBoxRight0 {
    position: absolute;
    width: 144px;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    border-radius: 0 144px 144px 0;
    right: -135px;
  }

  .mainBoxRight {
    border: 2px solid #0175c2;
    border-left: none;
  }

  .mainBoxRight0 {
    border: 2px solid #f4f4f4;
    border-left: none;
  }

  .mainBoxRight1 {
    position: absolute;
    width: 144px;
    top: 0;
    bottom: 0;
    background: #fff;
    z-index: 1;
    right: -135px;
    transform: scaleY(0);
    transform-origin: bottom center;
    animation: heightAni 1s linear 1;
  }

  .mainBoxLeft,
  .mainBoxLeft0 {
    position: absolute;
    width: 144px;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    border-radius: 144px 0 0 144px;
    left: -135px;
  }

  .mainBoxLeft {
    border: 2px solid #0175c2;
    border-right: none;
  }

  .mainBoxLeft0 {
    border: 2px solid #f4f4f4;
    border-right: none;
  }

  .mainBoxLeft1 {
    position: absolute;
    width: 144px;
    top: 0;
    bottom: 0;
    background: #fff;
    z-index: 1;
    left: -135px;
    transform: scaleY(0);
    transform-origin: bottom center;
    animation: heightAni 1s linear 1;
  }

  @keyframes widthAni {
    from { width: 0; }
    to { width: 558px; }
  }

  @keyframes heightAni {
    from { transform: scaleY(1); }
    to { transform: scaleY(0); }
  }

  .mianBox {
    width: 12px;
    min-height: 12px;
    background: transparent;
    border: none;
    box-shadow: none;
    margin-top: -6px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 88px;
    z-index: 2;

    &::before {
      content: '';
      width: 12px;
      height: 12px;
      flex-shrink: 0;
      background: #fff;
      box-shadow: 0 4px 4px rgba(5, 89, 187, 0.25);
      border: 2px solid #0175c2;
    }

    .mianBoxTitle {
      position: absolute;
      font-size: 36px;
      font-weight: bold;
      top: -60px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
    }

    .mianBoxDescription {
      position: relative;
      width: 200px;
      margin-top: 24px;
      color: #666;
      font-size: 17px !important;
      line-height: 1.5;
      word-break: break-word;
      overflow-wrap: break-word;

      ::v-deep p {
        margin: 0;
        line-height: 1.5;
      }
    }
  }

  .mainSnakLine:last-child .mianBox {
    padding-bottom: 40px;
  }

  .mainBoxData {
    position: absolute;
    left: -150px;
    top: -86px;
    width: 200px;
    height: 88px;
    background: #0175c2;
    font-size: 30px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .right.contact-panel {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    min-height: 342px;
    height: auto;
  }

  .contact-map {
    flex-shrink: 0;
    margin: 20px 0 20px 20px;

    #map-pc {
      width: 400px;
      height: 400px;
    }
  }

  .contact-info {
    flex: 1;
    margin: 40px 20px 20px 40px;
  }

  .contact-panel {
    .companyName {
      font-size: 20px;
      font-weight: bold;
      color: #000;
      margin-bottom: 10px;
    }

    .address {
      font-size: 16px;
      color: #333;
      margin-bottom: 8px;
    }
  }

  .article-nav {
    width: 900px;
    margin: 20px auto 0;

    .upNews {
      display: flex;
      padding: 10px 0;
      cursor: pointer;
      border-top: 1px dashed #e5e5e5;

      .upNewsIcon {
        color: #0175c2;
        margin-right: 10px;
        white-space: nowrap;
      }

      .upNewsText {
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.typeStyle {
  width: 150px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  border: 1px solid #e5e5e5;
  border-bottom: none;
}

.typeStyle1 {
  background: #0175c2;
  color: #fff;
  border: none;
}

.org-chart,
.picture-gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px 0;
}

.org-chart-item,
.picture-gallery-item {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;

  img {
    max-width: 100%;
    height: auto;
  }
}

.article-panel {
  .newsItem {
    display: flex;
    width: 885px;
    margin: 0 auto;
    padding: 20px 0;
    border-bottom: 1px dashed #e5e5e5;
    cursor: pointer;

    img {
      width: 200px;
      height: 150px;
      object-fit: cover;
      margin-right: 20px;
    }

    .newsItem-content {
      flex: 1;

      .title {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;
      }

      .time {
        font-size: 14px;
        color: #999;
      }
    }
  }

  .article-list-row {
    display: flex;
    width: 885px;
    height: 50px;
    align-items: center;
    border-bottom: 1px dashed #e5e5e5;
    margin: 0 auto;
    cursor: pointer;

    .article-list-title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 750px;
      font-size: 16px;
      color: #333;
    }

    .article-list-time {
      margin-left: auto;
      font-size: 14px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cms/renders/CmsContentRender.vue